import HttpServices from './HttpServices';
import { ProcessWorkflowState, ProcessType, CreateProcessRequest, ProcessState, ProcessRequestStatus, ProcessWorkflowConfiguration } from './WorkflowServicesTypes';


export default class WorkflowServices {
	HttpServices: HttpServices;
	BO_API_URL: string;
	accountId: string;

	fake: { getProcessCallNumber: number, useFake: boolean, incr: () => void };

	constructor(accId: string, $http: any, fake?: { getProcessCallNumber: number, useFake: boolean, incr: () => void } | null) {
		this.HttpServices = new HttpServices($http);
		this.accountId = accId;
		if (!window || !(window as any).BEYABLE_env || !(window as any).BEYABLE_env.BO_API_URL) {
			throw 'Configuration [window.BEYABLE_env.BO_API_URL] missing';
		}
		else {
			this.BO_API_URL = `${(window as any).BEYABLE_env.BO_API_URL}`;
		}

		this.fake = fake ?? { getProcessCallNumber: 0, useFake: false, incr: () => { undefined; } };
	}
	getProcesses(callbackSuccess: (success: ProcessWorkflowState[]) => void, callbackError: ((error: string, dataError: any) => void)): void {
		if (this.fake.useFake) {
			callbackSuccess(fakeProcesses);
		} else {
			const url = `${this.BO_API_URL}${this.accountId}/workflow-state`;
			this.HttpServices.get(url, callbackSuccess, callbackError);
		}
	}

	getProcess(processType: ProcessType, callbackSuccess: (success: ProcessWorkflowState) => void, callbackError: ((error: string) => void)): void {
		if (this.fake.useFake) {
			if (this.fake.getProcessCallNumber < 4) {
				console.log('TerminatedWithSuccess - no PendingRequest', fakeProcessTerminatedWithSuccessNoPendingRequest);
				callbackSuccess(fakeProcessTerminatedWithSuccessNoPendingRequest);
			} else if (this.fake.getProcessCallNumber < 7) {
				console.log('TerminatedWithSuccess - PendingRequest', fakeProcessTerminatedWithSuccessWithPendingRequest);

				callbackSuccess(fakeProcessTerminatedWithSuccessWithPendingRequest);
			} else if (this.fake.getProcessCallNumber < 10) {
				console.log('Ongoing - PendingRequest', fakeProcessOngoingWithPendingRequest);

				callbackSuccess(fakeProcessOngoingWithPendingRequest);
			} else if (this.fake.getProcessCallNumber < 13) {
				console.log('Ongoing - no PendingRequest', fakeProcessOngoingNoPendingRequest);

				callbackSuccess(fakeProcessOngoingNoPendingRequest);
			} else if (this.fake.getProcessCallNumber < 17) {
				console.log('TerminatedWithError - no PendingRequest', fakeProcessTerminatedWithErrorNoPendingRequest);

				callbackSuccess(fakeProcessTerminatedWithErrorNoPendingRequest);
			}
			this.fake.incr();
			console.log(this.fake.getProcessCallNumber);
		} else {
			const url = `${this.BO_API_URL}${this.accountId}/workflow-state/${processType}`;
			this.HttpServices.get(url, callbackSuccess, callbackError);
		}
	}
	accountWorkflowRequest(requests: CreateProcessRequest[], callbackSuccess, callbackError: ((error: string, dataError: any) => void)): void {
		const url = `${this.BO_API_URL}${this.accountId}/workflow-request`;
		this.HttpServices.post(url, requests, callbackSuccess, callbackError);
	}
	getAccountConfiguration(callbackSuccess: (success: ProcessWorkflowConfiguration) => void, callbackError: ((error: string) => void)): void {
		const url = `${this.BO_API_URL}${this.accountId}/workflow-configuration`;
		this.HttpServices.get(url, callbackSuccess, callbackError);
	}
}



const fakeProcessTerminatedWithSuccessNoPendingRequest: ProcessWorkflowState = {
	processType: ProcessType.ProductFeed,
	mainState: {
		processIdentifier: '',
		lastSuccessDateUtc: null,
		message: 'truc machin',
		processState: ProcessState.TerminatedWithSuccess,
		stateDateUtc: '2025-04-28T08:58:17.4',
		requests: []
	},
	stateWithIdentifiers: []
};

const fakeProcessTerminatedWithErrorNoPendingRequest: ProcessWorkflowState = {
	processType: ProcessType.ProductFeed,
	mainState: {
		processIdentifier: '',
		lastSuccessDateUtc: null,
		message: 'truc machin',
		processState: ProcessState.TerminatedWithError,
		stateDateUtc: '2025-04-28T08:58:17.4',
		requests: []
	},
	stateWithIdentifiers: []
};
const fakeProcessTerminatedWithSuccessWithPendingRequest: ProcessWorkflowState = {
	processType: ProcessType.ProductFeed,
	mainState: {
		processIdentifier: '',
		lastSuccessDateUtc: null,
		message: 'truc machin',
		processState: ProcessState.TerminatedWithSuccess,
		stateDateUtc: '2025-04-28T08:58:17.4',
		requests: [
			{
				requestStatus: ProcessRequestStatus.Pending,
				requestDateUtc: '2025-04-14T15:57:13.5024915',
				originatorServiceName: null,
				originatorUserEmail: 'romain@beyable.com'
			}
		]
	},
	stateWithIdentifiers: []
};
const fakeProcessOngoingWithPendingRequest: ProcessWorkflowState = {
	processType: ProcessType.ProductFeed,
	mainState: {
		processIdentifier: '',
		lastSuccessDateUtc: null,
		message: 'truc machin',
		processState: ProcessState.OnGoing,
		stateDateUtc: '2025-04-28T08:58:17.4',
		requests: [
			{
				requestStatus: ProcessRequestStatus.Pending,
				requestDateUtc: '2025-04-14T15:57:13.5024915',
				originatorServiceName: null,
				originatorUserEmail: 'romain@beyable.com'
			}
		]
	},
	stateWithIdentifiers: []
};
const fakeProcessOngoingNoPendingRequest: ProcessWorkflowState = {
	processType: ProcessType.ProductFeed,
	mainState: {
		processIdentifier: '',
		lastSuccessDateUtc: null,
		message: 'truc machin',
		processState: ProcessState.OnGoing,
		stateDateUtc: '2025-04-28T08:58:17.4',
		requests: []
	},
	stateWithIdentifiers: []
};

const fakeProcesses = [
	{
		processType: ProcessType.Compositions,
		mainState: {
			processIdentifier: '',
			lastSuccessDateUtc: null,
			message: '',
			processState: ProcessState.TerminatedWithSuccess,
			stateDateUtc: '2025-04-28T08:58:17.4',
			requests: []
		},
		stateWithIdentifiers: []
	},
	{
		processType: ProcessType.PersonalisedCompositions,
		mainState: {
			processIdentifier: '',
			lastSuccessDateUtc: null,
			message: '',
			processState: ProcessState.TerminatedWithSuccess,
			stateDateUtc: '2025-04-28T08:58:17.4',
			requests: []
		},
		stateWithIdentifiers: []
	},
	{
		processType: ProcessType.ProductFeed,
		mainState: {
			processIdentifier: '',
			lastSuccessDateUtc: null,
			message: '',
			processState: ProcessState.Pending,
			stateDateUtc: '2025-04-28T08:58:17.4',
			requests: []
		},
		stateWithIdentifiers: []
	},
	{
		processType: ProcessType.ProductRecommendations,
		mainState: {
			processIdentifier: '',
			lastSuccessDateUtc: null,
			message: 'One or more errors occurred. (The service sheets has thrown an exception. HttpStatusCode is TooManyRequests. Quota exceeded for quota metric ‘Read requests’ and limit ‘Read requests per minute per user’ of service ‘sheets.googleapis.com’ for consumer ‘project_number:727303599000’.)',
			processState: ProcessState.TerminatedWithError,
			stateDateUtc: '2025-04-28T08:58:17.4',
			requests: [
				// {
				// 	requestStatus: ProcessRequestStatus.Pending,
				// 	requestDateUtc: '2025-04-14T15:57:13.5024915',
				// 	originatorServiceName: null,
				// 	originatorUserEmail: 'romain@beyable.com'
				// }
			]
		},
		stateWithIdentifiers: [
			{
				processIdentifier: '230836c7-0452-4089-b932-35d70ac00c9a',
				lastSuccessDateUtc: null,
				message: '',
				processState: ProcessState.TerminatedWithSuccess,
				stateDateUtc: '2025-03-25T07:41:26.47',
				requests: []
			},
			{
				processIdentifier: '230836c7-0452-4089-b932-35d70ac00c9b',
				lastSuccessDateUtc: null,
				message: '',
				processState: ProcessState.TerminatedWithSuccess,
				stateDateUtc: '2025-03-25T07:41:26.47',
				requests: []
			},
			{
				processIdentifier: '230836c7-0452-4089-b932-35d70ac00c9c',
				lastSuccessDateUtc: null,
				message: '',
				processState: ProcessState.TerminatedWithSuccess,
				stateDateUtc: '2025-03-25T07:41:26.47',
				requests: []
			}
		]
	},
	{
		processType: ProcessType.ProductRanking,
		mainState: {
			processIdentifier: '',
			lastSuccessDateUtc: null,
			message: '',
			processState: ProcessState.OnGoing,
			stateDateUtc: '2025-04-28T08:58:17.4',
			requests: [
				{
					requestStatus: ProcessRequestStatus.Pending,
					requestDateUtc: '2025-04-14T15:57:13.5024915',
					originatorServiceName: null,
					originatorUserEmail: 'romain@beyable.com'
				},
				{
					requestStatus: ProcessRequestStatus.Pending,
					requestDateUtc: '2025-04-14T15:57:13.5024915',
					originatorServiceName: null,
					originatorUserEmail: 'romain@beyable.com'
				}
			]
		},
		stateWithIdentifiers: []
	}
];